<template>
	<div class="border-top">
		<SOFilterTitle :title="'Workshop'" :diterapkan="diterapkan" :id="id"/>
		<div class="p-l-24 p-r-24 p-d-24" v-show="false" :id="id">
			<SOFilterCheckboxSkeleton v-if="pageSetting.loading"/>
			<SOInputCheckbox
				:checkboxes="checkboxWorkshop"
				:checked="filterItem.workshop"
				:limit-loop="true"
				:limit-loop-count="4"
				:use-check-all="useCheckAll"
				:modal-id="'more-workshop'"
				:modal-title="'Workshop'"
				@selected="selected"
			/>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex"

import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOFilterCheckboxSkeleton from "@/so-components/global/filter/skeleton/SOFilterCheckboxSkeleton";
import SOInputCheckbox from "@/so-components/global/input/SOInputCheckbox";

export default {
	name: "SOFilterWorkshop",
	components: {
		SOFilterTitle,
		SOFilterCheckboxSkeleton,
		SOInputCheckbox,
	},
	props: {
		id: String,
		title: String,
		useCheckAll: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		...mapGetters("filterGlobalModule", {
			filterItem: "getFilterItem"
		}),
		...mapGetters("metaModule", {
			workshops: "getWorkshop",
		})
	},
	data() {
		return {
			checkboxWorkshop: {
				name: "workshop",
				data: []
			},
			pageSetting: {
				loading: true,
			},
			diterapkan: false
		}
	},
	mounted() {
		if (this.title === "") {
			this.title = "Workshop"
		}
		this.getWorkshop()
		this.diterapkan = this.filterItem.workshop.length > 0
	},
	methods: {
		async getWorkshop() {
			this.pageSetting.loading = true
			const res = await this.$store.dispatch("metaModule/fetchWorkshopAllTiny")
			this.pageSetting.loading = false
			if (!res.success) {
				this.$toast.error(res.err)
				return
			}
			this.workshops.forEach((item) => {
				this.checkboxWorkshop.data = [...this.checkboxWorkshop.data, {
					id: "fworkshop-" + item.idworkshop,
					value: item.idworkshop,
					title: item.nama,
					checked: false,
					titleBold: false,
					disabled: item.hapus === 1
				}]
			})
		},
		selected(val) {
			let selected = [];
			if (typeof val === "string") {
				if (val === "checkAll") {
					this.workshops.forEach(item => {
						selected.push(item.idworkshop);
					});
				} else {
					selected = [];
				}
			} else {
				selected = val;
			}

			let temp = this.filterItem
			temp.workshop = selected
			this.$store.commit("filterGlobalModule/setFilterItem", temp)
			this.diterapkan = this.filterItem.workshop.length > 0
		}
	}
}
</script>